import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators, FormBuilder } from '@angular/forms';
import { searchFilterBy, searchFilterSubject } from 'src/app/services/data.service';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Environment } from 'src/app/stores/environment.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AutoCompleteStore } from 'src/app/stores/autocomplete.store';
import { debounceTime, tap, switchMap } from 'rxjs/operators';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';
import { AddEnrollReadingComponent } from './add-enroll-reading/add-enroll-reading.component';
import { DeleteComponent } from 'src/app/components/delete/delete.component';

@Component({
  selector: 'app-enroll-reading',
  templateUrl: './enroll-reading.component.html',
  styleUrls: ['./enroll-reading.component.scss']
})
export class EnrollReadingComponent implements OnInit {
  formFocus: boolean;
  form: FormGroup;
  search: AbstractControl;
  searchType: AbstractControl;
  filterBy = searchFilterSubject;
  loading: boolean = false;
  admissionKey: string;
  enrollmentKey: string;
  block: boolean = false;
  creditRef: any;
  creditAmount: number;
  scholarshipPenalty: number;
  scholarshipPenaltyRef: any;
  statusRef: any;

  filteredStates: Observable<any[]>;
  shiftControl = new FormControl('', [Validators.required]);
  programControl = new FormControl(null, [Validators.required]);
  programs;
  process: boolean = false;

  isValidKey: boolean = false;
  isAdmin: boolean = false;
  autoStudent;
  constructor(
    public env: Environment,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private autoStore: AutoCompleteStore,
    public store: ClassroomStore,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.env.getUser(res => {
      this.isAdmin = false;
    })

    this.buildForm();
    this.route.parent.params.subscribe(param => {

      this.store.fetchReading(param.id);
    })

    this.autoStore.fetchAutoDataCallBack('subjects', data => {
      if (data) {
        this.autoStudent = data;
      }
    });

    this.search.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => (false)),
        switchMap(value => this.autoStore.fetchSearchCallback("subjects", this.searchType.value.key, value, data => {
          if (data) {
            this.autoStudent = data;
          }
        }))
      ).subscribe(res => { });
  }

  _onSelectedChange(event) {

  }

  _release() {

  }

  buildForm() {
    this.form = this.fb.group({
      searchType: [searchFilterBy[0], [Validators.required]],
      search: [null]
    });
    this.search = this.form.controls["search"];
    this.searchType = this.form.controls["searchType"];
  }

  displayItem(item: any): string {
    if (this.searchType) {
      const { key } = this.searchType.value;
      return item ? item[key] : item;
    }
    return item ? item.code : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) {
      return o1.text === o2.text;
    }
  }

  create() {
    const dialogRef = this.dialog.open(AddEnrollReadingComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  // update(item) {
  //   const dialogRef = this.dialog.open(UpdateScheduleComponent, {
  //     data: item,
  //     panelClass: 'register-test-overlay-panel',
  //     width: '30vw',
  //     height: '100vh',
  //     disableClose: false,
  //     autoFocus: false,
  //     role: 'dialog',
  //   });
  //   dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
  //   dialogRef.afterClosed().subscribe(result => { });
  // }

  delete(item) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Reading Book', memo: 'If schedule is using by other function in system you cannot delete it.', name: item.title },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.deleteReadingBook(item, (success, error) => {
          if (success) {
            this.snackBar.open('Reading Book has been deleted successfully.', 'done', { duration: 2000 });
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }

  _goBack() {
    this.router.navigate(['/enrollment']);
  }

  _onFocus(yes) {
    this.formFocus = yes;
  }

  _onSearch(item: any) {
  }

  _optionSelected(item) {

  }

  onRouter(item, admissionKey) {


  }
  _selectionChange(event) {
    const { value } = event;
  }

  _selectionCourse(event) {

  }

  _remove(item) {


  }

  _saveEnroll(state) {
    if (this.form.valid) {
    }
  }

  _onEnrollCourse() {

  }

  _onUpdateCourseSchedule() {

  }

  _onBatchEnrollCourse() {


  }

}
